import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { ConsultaIngresoReclamos } from "./ConsultaIngresoReclamos";
import { useSelector } from "react-redux";
import { IngresoReclamos } from "./IngresoReclamos";
import { IngresoReclamosEfector } from "../ModalIngresoReclamoEfector/IngresoReclamosEfector";
import { IngresoReclamosExternos } from "../ModalIngresoReclamosExternos/StepperIngreso/IngresoReclamosExternos";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const ReclamosIngreso = () => {
  const classes = useStyles();
  const { dataAfiliado, dataEfector, dataExternos } = useSelector((state) => state.reclamos);


  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.center}>
          <ConsultaIngresoReclamos  />
        </Grid>
        <Grid item xs={12} className={classes.center}>
          {dataAfiliado?.id_afiliado > 0 && <IngresoReclamos />}
        </Grid>
        <Grid item xs={12} className={classes.center}>
          {dataEfector?.idEfectorFacturacion > 0 && <IngresoReclamosEfector />}
        </Grid>
        <Grid item xs={12} className={classes.center}>
          {dataExternos.length > 0 && <IngresoReclamosExternos />}
        </Grid>
      </Grid>
    </div>
  );
};
